import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { IonAlert, IonApp, IonRouterOutlet } from "@ionic/angular/standalone";
import { BasePage } from "./views/base/base.view";
import { ScriptService } from "./services/script.service";
import { LogService } from "./services/log.service";
import { UpdateService } from "./services/update.service";
import { handlePromise } from "../utils";
import { EnvironmentService } from "./services/environment.service";

@Component({
  imports: [IonApp, IonRouterOutlet, IonAlert],
  selector: "app-root",
  templateUrl: "app.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent extends BasePage {
  constructor(
    logService: LogService,
    scriptService: ScriptService,
    titleService: Title,
    private updateService: UpdateService,
    private environmentService: EnvironmentService,
  ) {
    super(logService, scriptService, "App", titleService);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this.setup();
  }

  public async customCloseAlert() {
    await this.updateService.update();
  }

  private async setup() {
    const [updateErr, updateInfo] = await handlePromise(
      this.updateService.checkForUpdate(),
    );
    if (updateErr) {
      this.logger.error("Failed to check for update", updateErr);
    }
    if (updateInfo?.updateAvailable) {
      const devMessage = this.environmentService.getBuild()
        ? `Build: ${updateInfo.currentBuild} &rarr; ${updateInfo.latestBuild}<br/>`
        : "";
      const updateMessage = this.updateService.isIOS
        ? "You will be redirected to the App Store to update the app."
        : "App will now reload for changes to take effect.";
      this.openAlert(
        this.updateService.isIOS
          ? "New Version Available"
          : "App Version Has Been Updated",
        ``,
        `Version: ${updateInfo.currentVersion} &rarr; ${updateInfo.latestVersion}<br/>${devMessage}${updateMessage}`,
        [
          {
            text: "OK",
            handler: async () => {
              await this.updateService.update();
            },
          },
        ],
      );
    }
  }
}
